export default "__VITE_ASSET__e45e832f__"